// src/Helper/Table.js
import React from "react";
import { Button, Form } from "react-bootstrap";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
} from "react-table";

// --- Columns ---
export const COLUMNS = [
  { Header: "Name", accessor: "Name", className: "wd-20p borderrigth" },
  { Header: "Position", accessor: "Position", className: "wd-25p borderrigth" },
  { Header: "Office", accessor: "Office", className: "wd-20p borderrigth" },
  { Header: "Age", accessor: "Age", className: "wd-15p borderrigth" },
  { Header: "Salary", accessor: "Salary", className: "wd-20p borderrigth" },
];

// --- Sample data ---
export const DATATABLE = [
  { Id: "1", Name: "Tiger Nixon", Position: "System Architect", Office: "Edinburgh", Age: "61", Salary: "$320,800" },
  { Id: "2", Name: "Garrett Winters", Position: "Accountant", Office: "Tokyo", Age: "63", Salary: "$170,750" },
  // ... rest of your data
];

// src/Helper/Table.js
const CommonTable = ({ columns, data, pageSize = 10, manualPagination = false }) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageSize: pageSize }, // Make sure this is set
      manualPagination: manualPagination // If true, react-table won't paginate
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    headerGroups,
    getTableBodyProps,
    prepareRow,
    state,
    setGlobalFilter,
    page, // This is the paginated data
    rows, // This is ALL the data
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
  } = tableInstance;

  const { globalFilter, pageIndex, pageSize: currentPageSize } = state;

  // Use rows instead of page if manualPagination is true
  const rowsToDisplay = manualPagination ? rows : page;

  return (
    <>
      <div className="table-responsive subcheckbox">
        <table {...getTableProps()} className="table table-hover mb-0">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())} className={column.className}>
                    {column.render("Header")}
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rowsToDisplay.map((row) => { // Use rowsToDisplay instead of page
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()} className="borderrigth">
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

// --- Global filter component ---
const GlobalFilter = ({ filter, setFilter }) => (
  <Form.Control
    value={filter || ""}
    onChange={(e) => setFilter(e.target.value)}
    placeholder="Search..."
    className="form-control mb-4 ms-auto"
  />
);

export default CommonTable;
